import React from 'react';
import IconButton from './IconButton';

const SaveButton = ({
  disabled,
  iconName = 'checkmark',
  iconOnly,
  inProgress,
  messageId = 'actions.save',
  minimumDataEntryMet,
  onClick,
  otherSaveOptionSelected,
  secondary,
}) => (
  <IconButton
    className="aridhia-save-button"
    disabled={inProgress || !minimumDataEntryMet || disabled}
    icon
    iconName={iconName}
    iconOnly={iconOnly}
    loading={inProgress && !otherSaveOptionSelected}
    messageId={messageId}
    onClick={onClick}
    positive={!secondary}
    secondary={secondary}
  />
);

export default SaveButton;
